const columns = [
    {
      title: "Rule Name",
      dataIndex: "ruleName",
    },
    {
      title: "Description",
      dataIndex: "description",
    //   width:100
    },
    {
      title: "Rule Type",
      dataIndex: "ruleType",
    },
   
    {
      title: "Is Active",
      dataIndex: "isDefault",
    },
    {
        title: "Minimum Transfer",
        dataIndex: "condition1",
      },
      {
        title: "Maximum Transfer",
        dataIndex: "condition2",
      },
    {
      title: "Actions",
      dataIndex: "actions",
    },
  ];
  
  export default columns;
  